import api from "./api";

const ADMIN_BASE = "/administration";
const ACCOUNTS_BASE = "/accounts";

export const getUserList = (params = {}) =>
  api.get(`${ACCOUNTS_BASE}/users/`, { params });

// Kept for backward compatibility — delegates to getUserList.
export const getUsers = (params = {}) =>
  api.get(`${ACCOUNTS_BASE}/users/`, { params });

export const getAuditLogs = (params = {}) =>
  api.get(`${ADMIN_BASE}/audit-logs/`, { params });

export const getSupportTickets = (params = {}) =>
  api.get(`${ADMIN_BASE}/support-tickets/`, { params });

export const getSystemConfig = () =>
  api.get(`${ADMIN_BASE}/config/`);

export const createSystemConfig = (data) =>
  api.post(`${ADMIN_BASE}/config/`, data);

export const updateSystemConfig = (id, data) =>
  api.patch(`${ADMIN_BASE}/config/${id}/`, data);

export const createSupportTicket = (data) =>
  api.post(`${ADMIN_BASE}/support-tickets/`, data);

export const updateSupportTicket = (id, data) =>
  api.patch(`${ADMIN_BASE}/support-tickets/${id}/`, data);

export const createUser = (data) =>
  api.post(`${ACCOUNTS_BASE}/users/`, data);

export const suspendUser = (id) =>
  api.patch(`${ACCOUNTS_BASE}/users/${id}/`, { is_active: false });

export const activateUser = (id) =>
  api.patch(`${ACCOUNTS_BASE}/users/${id}/`, { is_active: true });

export const getBillingRecords = (params = {}) =>
  api.get('/billing/records/', { params });

export const getUserCount = async () => {
  const response = await api.get(`${ACCOUNTS_BASE}/users/`);
  const users = Array.isArray(response.data)
    ? response.data
    : (response.data.results ?? []);
  return { ...response, data: { count: users.length } };
};

// ── Admin Notifications ───────────────────────────────────────────────────────
export const getAdminNotifications = () =>
  api.get(`${ADMIN_BASE}/notifications/`);

export const getAdminNotificationUnreadCount = () =>
  api.get(`${ADMIN_BASE}/notifications/unread-count/`);

export const markAdminNotificationsRead = (ids) =>
  api.post(`${ADMIN_BASE}/notifications/mark-read/`, { ids });

export const markAllAdminNotificationsRead = () =>
  api.post(`${ADMIN_BASE}/notifications/mark-all-read/`);

// ── User management (admin actions) ──────────────────────────────────────────
export const resetUserPassword = (id, body = {}) =>
  api.post(`${ACCOUNTS_BASE}/users/${id}/reset-password/`, body);

export const reassignUserOrg = (id, orgId) =>
  api.post(`${ACCOUNTS_BASE}/users/${id}/reassign-org/`, { org_id: orgId });

// ── Signup request approval queue ────────────────────────────────────────────
export const getSignupRequests = (status) =>
  api.get(`${ACCOUNTS_BASE}/signup-requests/`, { params: status ? { status } : {} });

export const approveSignupRequest = (id, data = {}) =>
  api.post(`${ACCOUNTS_BASE}/signup-requests/${id}/approve/`, data);

export const rejectSignupRequest = (id, reason) =>
  api.post(`${ACCOUNTS_BASE}/signup-requests/${id}/reject/`, { reason });
